import _ from 'lodash';
import ValidationUtils from './ValidationUtils';
import Messages from './Messages';

const MoveAddressValidator = (values) => {
  const requiredFields = [
    {
      name: 'connectionDate',
      errorMessage: Messages.REQUIRED_CONNECTION_DATE
    }
  ];
  let errors = ValidationUtils.validateRequiredFields(requiredFields, values);

  if (values.connectionDate && values.connectionDate === 'preferred') {
    errors = _.merge(errors, ValidationUtils.validateRequiredFields([{
      name: 'preferredDate',
      errorMessage: Messages.REQUIRED_CONNECTION_DATE
    }], values));
  }
  return errors;
};

export default MoveAddressValidator;



/** WEBPACK FOOTER **
 ** ./src/common/validation/MoveAddressValidator.js
 **/